module.exports = __webpack_public_path__ + "media/images/reseller-df2be4eff4203184fff4d189a89bd622.jpg";